import React from 'react';
import cadeauImg from '../assets/cadeau.jpg';

const CollectionSection = () => {
  return (
    <section className="section" style={{backgroundColor: '#F4F1EE'}}>
      <div className="container">
        <div className="split" style={{flexDirection: 'row-reverse'}}>
          <div className="split-img" style={{backgroundImage: `url(${cadeauImg})`}}></div>
          <div className="split-content">
            <span className="tagline">La Boutique</span>
            <h2>Objets de Caractère</h2>
            <p className="description">
              Des sous-plats en argile aux objets décoratifs uniques, conçus pour apporter une touche chaleureuse à chaque intérieur.
            </p>
            <a href="https://www.instagram.com/fabria.store/" target="_blank" rel="noopener noreferrer" className="btn">
              Découvrir
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollectionSection;
